<style lang="less" scoped>
    .main-container {
        width: 100%;
        height: 100%;
    }
</style>


<template>
    <div class="main-container">
        <router-view v-if="hasLogin"></router-view>
    </div>
</template>

<script>
    const user1 = {
        "mobile": "15312341234",
        "corpNo": "CO1564365540801",
        "sysId": "c05c1ed3f9f66674b557f31d82d0ac0a"
    };
    const user2 = {
        "mobile": "18261576531",
        "corpNo": "CO1564365540801",
        "sysId": "c05c1ed3f9f66674b557f31d82d0ac0a"
    };
    export default {
        data() {
            return {
                hasLogin: false,
                token: '',
            }
        },
        methods: {
            initH5() {
                let _ = this;
                // TODO test pre
                _.hasLogin = false;

                // 登录
                this.$H.post(this, this.$A.login, JSON.stringify(user1), function(res) {
                    _.$store.commit('setToken', res.headers.authorization);
                    setTimeout(function(){
                        _.hasLogin = true;
                    },50)
                })
            },
            initApp() {
                let _ = this;
                _.hasLogin = false;
                var u = navigator.userAgent;
                var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //安卓端
                var isIos = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //IOS端
                if (isAndroid) {
                    _.$store.commit('setToken', jsBridge.getToken());
                    _.hasLogin = true;
                }
                if (isIos) {
                    window['getToken'] = function(res) {
                        _.$store.commit('setToken', res);
                        setTimeout(function(){
                            _.hasLogin = true;
                        },50);
                    }
                }
            }
        },
        computed: {},
        mounted() {
            this.$store.commit('setToken', '');
            var mode = this.$C.testMode;
            // h5
            if (mode == 'h5') {
                this.initH5();
            } else if (mode == 'app') {
                this.initApp();
            }
        }
    }
</script>




// WEBPACK FOOTER //
// src/views/Main.vue